/**
 * Utility functions for updating text state consistently
 */

/**
 * Update both texts array and selectedText with the same changes
 */
export const updateTextAndSelectedText = ({
  textId,
  setTexts,
  setSelectedText,
  updates,
}) => {
  setTexts((prev) =>
    prev.map((t) => (t.id === textId ? { ...t, ...updates } : t))
  );

  setSelectedText((prev) => {
    if (!prev) return prev;
    return { ...prev, ...updates };
  });
};

/**
 * Update a specific field in both texts array and selectedText
 */
export const updateTextField = ({
  textId,
  field,
  value,
  setTexts,
  setSelectedText,
}) => {
  updateTextAndSelectedText({
    textId,
    setTexts,
    setSelectedText,
    updates: { [field]: value },
  });
};

/**
 * Update text with callback for complex updates
 */
export const updateTextWithCallback = ({
  textId,
  setTexts,
  setSelectedText,
  textUpdater,
  selectedTextUpdater,
}) => {
  setTexts((prev) => prev.map((t) => (t.id === textId ? textUpdater(t) : t)));

  if (selectedTextUpdater) {
    setSelectedText((prev) => (prev ? selectedTextUpdater(prev) : prev));
  } else if (textUpdater) {
    setSelectedText((prev) => (prev ? textUpdater({ ...prev }) : prev));
  }
};

/**
 * Update only selectedText/selectedObject immediately for visual feedback
 * This provides instant sync without updating the full texts array
 */
export const updateSelectedTextOnly = ({
  setSelectedText,
  setSelectedObject,
  updates,
  textUpdater,
}) => {
  if (setSelectedText) {
    if (textUpdater) {
      setSelectedText((prev) => (prev ? textUpdater(prev) : prev));
    } else {
      setSelectedText((prev) => {
        if (!prev) return prev;
        return { ...prev, ...updates };
      });
    }
  }

  if (setSelectedObject) {
    if (textUpdater) {
      setSelectedObject((prev) => {
        if (!prev || prev.type !== "Text") return prev;
        return { ...prev, ...textUpdater(prev) };
      });
    } else {
      setSelectedObject((prev) => {
        if (!prev || prev.type !== "Text") return prev;
        return { ...prev, ...updates };
      });
    }
  }
};
